"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgArrowCircleBrokenUpRight = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsx)("path", { d: "M6.389 21.464c-.443-.263-.665-.394-.796-.642a1.092 1.092 0 0 1-.089-.706c.067-.272.276-.482.695-.9l7.63-7.63v3.242a1 1 0 1 0 2 0V9.172a1 1 0 0 0-1-1H9.171a1 1 0 0 0 0 2h3.242l-7.63 7.63c-.418.418-.628.628-.9.694-.217.053-.509.016-.706-.089-.248-.131-.38-.353-.642-.796C.029 13.391.59 7.853 4.222 4.221c4.296-4.295 11.26-4.295 15.556 0 4.296 4.297 4.296 11.261 0 15.557-3.63 3.631-9.168 4.193-13.39 1.686Z", fill: "currentColor" }) }))); };
exports.default = SvgArrowCircleBrokenUpRight;
